(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyInfoController', CompanyInfoController);

    CompanyInfoController.$inject = ['__config', '$timeout', '$scope', '$stateParams', 'Company', 'SettingInfo', 'AgreementInfo', 'LocationInfo', 'MetaTag', 'CompanyInfoQuery', 'Principal', 'CompanyCustom'];

    function CompanyInfoController(__config, $timeout, $scope, $stateParams, Company, SettingInfo, AgreementInfo, LocationInfo, MetaTag, CompanyInfoQuery, Principal, CompanyCustom) {
        var vm = this;
        vm.scope = $scope;
        vm.__config = __config;
        vm.isCompanyNameValid = isCompanyNameValid;
        vm.isUrlValid = true;
        //
        //vm.company = entity;
        vm.company = CompanyInfoQuery.getCurrentCompanyInfo().query();
        vm.clear = clear;
        vm.save = save;
        //vm.settinginfos = SettingInfo.query();
        //vm.agreementinfos = AgreementInfo.query();
        //vm.locationinfos = LocationInfo.query();
        vm.metatags = MetaTag.query();
        vm.metatagOptions = {
            placeholder: "--",
            dataTextField: "tag",
            //dataValueField: "id",
            valuePrimitive: true,
            autoBind: false,
            dataSource: vm.metatags
        };

        vm.activityTypes = CompanyCustom.getCompanyActivityTypes();

        // $timeout(function (){
        //     angular.element('.form-group:eq(1)>input').focus();
        // });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {

            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.company.id !== null) {
                    Company.update(vm.company, onSaveSuccess, onSaveError);
                } else {
                    //Company.save(vm.company, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyUpdate', result);

            if (result)
                Principal.setCurrentCompany(result);

            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function isCompanyNameValid() {
            vm.isUrlValid = field_keyUrl.checkValidity();
        }


    }
})();
